import { render, staticRenderFns } from "./brokerage-settings-container.vue?vue&type=template&id=434ca755"
import script from "./brokerage-settings-container.vue?vue&type=script&lang=js"
export * from "./brokerage-settings-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports